import IconButton from "@mui/material/IconButton";
import IconClose from "@mui/icons-material/Close";
import { SnackbarKey, useSnackbar } from "notistack";
import { useCallback } from "react";

interface Props {
  snackbarKey: SnackbarKey
}

const SnackbarCloseButton = ( props: Props ) => {
  const
    { closeSnackbar } = useSnackbar(),
    {snackbarKey} = props,
    onClose = useCallback(() => {
      closeSnackbar( snackbarKey );
    }, [snackbarKey]);
  return (
    <IconButton onClick={onClose} size="small">
      <IconClose sx={{color: "#fff"}} fontSize="inherit"/>
    </IconButton>
  );
};

export default SnackbarCloseButton;